module.exports = __webpack_public_path__ + "img/jd_pro_small.90cadad8.png";